import { DateTime } from "luxon";
import confirmated_click from '../confirmated_click.fn.js';
import i18n from '../i18n.obj.js';
import fetcher from '../fetcher.fn.js';


/*

	Forms fields validators

*/

const validators = {
	identical: function( el, rel, errors ){

		rel = el.form.querySelector(`[name="${ rel }"]`);
		if( rel.value ){

			let rel_label = rel.closest('label').getAttribute('data-label');
			if( rel.value != el.value ){
				errors.add( i18n.ru( 'Value must be identical to the "{}" field value', [ rel_label ]) );
			}


		}

	},

	newPassword: function( el, rel, errors ){

		let inputs = [...el.closest('div').querySelectorAll('input')];

		// Both
		if( inputs.filter((i) => i.blured).length !== 2 ) {

			// The second input was not even ficused once, reseeting errors for it
			if( el === inputs[1] )
				errors.ignore();

			return;
		}

		let identical = inputs.reduce((acc,inp) => ( inp.value && acc === null || inp.value === acc ? inp.value : false) , null);

		if( !identical && el === inputs[1] ){
			errors.add( i18n.ru('Passwords must match') );
		}


	},

	more: function (el, rel, errors, is_less) {

		rel = el.form.querySelector(`[name="${ rel }"]`);
		let rel_label = rel.closest('label').getAttribute('data-label');

		// The check is reported okay when the rel element has no value
		// rel needs to be marked as `required` to prevent incorrect null value to be submitted
		let bad_value = (
			is_less
			? () => el.value && rel.value && rel.value < el.value
			: () => el.value && rel.value && rel.value > el.value
		);

		if( bad_value() )
			errors.add( i18n.ru( `Value must ${is_less ? 'not ':''}exceed the "{}" field value`, [ rel_label ]) );

		
	},
	less: function(el, rel, errors ){

		return this.more( el, rel, errors, true )

	},

	either: function( el, rel, errors ){

		rel = el.form.querySelector(`[name="${ rel }"]`);
		[el,rel].map((i) => i.removeAttribute('required'));

		let rel_label = rel.closest('[data-label]').getAttribute('data-label');

		if( el.value == '' && rel.value == '' ){
			errors.add( i18n.ru( 'Either this or "{}" field must have a value', [ rel_label ]) );
		}

	},

	alias: function( el, rel, errors ){
		
		if( !el.value.match(/^[a-z0-9-]{3,}$/) )
			errors.add( i18n.ru( 'Alias field must have a value consisting of latin letters, digits or dash', [ rel_label ]) );

	},

	// Single value must be present
	exclusive: function( el, rel, errors ){

		if( el.value ){
			let rel_input = el.form.elements[rel];
			if(
				rel_input.value
				&&
				!rel_input.disabled
			){

				let rel_label = rel_input.closest('[data-label]').getAttribute('data-label');
				errors.add( i18n.ru( 'Only one value must present here or for field: "{}"', [ rel_label ]) );

			}
			
		}

	}
	
}


/*

	Forms fields handlers

*/

class GenericInput{
	static getInstance(el){
		return new this( el );
	}
}

class Image extends GenericInput{
	constructor( el ){
		super()
		this.el = el;

		this.image = el.parentNode.querySelector(':scope > img');
		this.value_input = el.parentNode.querySelector(':scope > input[type="hidden"]');

		let a = el.parentNode.querySelector(':scope > a');

		el.parentNode.addEventListener('click', (e) => {
			if( e.target.tagName == 'A' ){
				e.preventDefault();
				return false;
			}
		});

		a.addEventListener('click', (e) => {
			this.image.removeAttribute('src');
			// let new_el = el.cloneNode(true);
			// this.el.insertAdjacentElement('afterend', new_el);
			// this.el.remove();
			// this.el = new_el;
			// this.initEvents();
			this.value_input.value = '1';
			this.el.value = '';
		});


		this.initEvents();


	}

	initEvents( ){
		this.el.addEventListener('change', (e) => {

			let file = this.el.files[0];

			if (file) {
			    let reader = new FileReader();
			    reader.onload = (e) => {

					if( ! e.target.result.match(/^data:image\/\w+;base64,/) )
						return;

			        this.image.src = e.target.result;
			        this.image.removeAttribute('srcset');

					// The file input might be standalone
					if( !this.el.name )
		        		this.value_input.value = e.target.result;

			    };

			    reader.readAsDataURL(file);
			}
		});
	}
}


class NumberInput extends GenericInput{
	constructor( el ){
		super()
		el.addEventListener('input', (e) => {
			el.value = el.value.replace(/[^0-9]/g,'');
		})
	}
}

class Alias extends GenericInput{
	constructor( el ){
		super()
		el.addEventListener('input', (e) => {
			el.value = el.value.toLowerCase().replace(/[^a-z0-9-]/g,'');
		})
	}
}

class NewPassword extends GenericInput{

	static instances = null;

	static getInstance(el){
		if( this.instances == null ){
			this.instances = new WeakMap();
		}

		let container = el.closest('div');
		let first_input = container.querySelector('input[type="password"]');

		if( this.instances.has( first_input ) ){
			let instance = this.instances.get( first_input );
			instance.addInput(el);
			return instance;
		}

		let instance = super.getInstance(el);
		this.instances.set( el, instance );

		return instance;
	}

	inputs = [];

	constructor( el ){
		super()
		this.addInput(el);
	}

	addInput( el ){
		if( !this.inputs.includes(el) )
			this.inputs.push(el);

		if( this.inputs.length === 2 ){
			let setter = {
				handleEvent: function(e){
					e.target.blured = true;
					e.target.removeEventListener('change',this);
					e.target.removeEventListener('blur',this);
				}
			};

			this.inputs.map((i) => i.addEventListener('blur', setter));
			this.inputs.map((i) => i.addEventListener('change', setter));
		}
	}
}

class Either extends GenericInput{
	constructor(el){
		super()
		let rel = el.form.querySelector(`[name="${ el.getAttribute('data-rel') }"]`);
		if( [el,rel].some((i) => i.value) )
			[el,rel].map((i) => i.removeAttribute('required'));
	}
}

class DateInput extends GenericInput{
	constructor( el ){
		super()
		if( !DateInput.tz_offset ){
			DateInput.tz_offset = true;
			el.form.insertAdjacentHTML(
				'afterbegin',
				`<input type='hidden' name='tz_offset' value="${(new Date()).getTimezoneOffset()}" />`
			)
		}

	}
}

class HTML extends GenericInput{

	constructor(el){
		super()
		let quill = new Quill(
			el.parentNode.querySelector(':scope > .editor'),
			{
				theme: 'bubble',
				// debug: 'log',
				placeholder: el.getAttribute('placeholder'),
			}
		);

		// Access the tooltip and change the placeholder
		quill.theme.tooltip.root.querySelector('input[data-link]').placeholder = '';
 
 		let tt = quill.theme.tooltip.root.querySelector('input[data-link]');
 		tt.placeholder = "https://example.com";
 		tt.setAttribute('data-link', 'https://example.com');

		el.form.addEventListener('formdata', (e) => {

			el.value = quill.getSemanticHTML().replace(/&nbsp;|\u00A0/g, ' ');
			e.formData.set( el.name, el.value );


		});


	}	
}

class Toggler extends GenericInput{

	static initialized = null;

	constructor( el ){
		super()
		if( this.constructor.initialized === null )
			this.constructor.initialized = {};

		if( this.constructor.initialized[ el.name ] )
			return;

		this.constructor.initialized[ el.name ] = true;

		let elements = [...el.form.elements[el.name]];
		elements.map(( radio ) => {
			radio.addEventListener('change', () => {

				elements.map(( check_input ) => {

					check_input
						.getAttribute('data-disable-target')
						.split(',')
						.map((name) => {
							el.form.elements[name].disabled = check_input.checked
						})


				})

			})
		});


	}

}



class FormErrorsSet{
	errors = [];

	add( e ){
		if( this.errors )
			this.errors.push( e );
	}

	get length(){
		return this.errors ? this.errors.length : 0;
	}

	toString(){
		return this.errors ? this.errors.join("\n") : '';
	}

	ignore(){
		this.errors = null;
	}

	clean(){
		if( this.errors )
			this.errors = this.errors.filter((e) => e);
	}

}


export default class Form{

	static handlers = {
		
		"[type='file']:has( ~ img )": Image,
		"[type='number']": NumberInput,
		'[autocomplete="new-password"]': NewPassword,
		'[data-validate="either"]': Either,
		'[type="hidden"][data-type="HTML"]': HTML,
		// '[type="hidden"][data-type="time_period"]': TimePeriod,		
		'[data-validate="alias"]': Alias,
		'[type="date"]': DateInput,
		'[data-toggle]': Toggler,
	}

	clone(){

		let element = this.form.cloneNode( true );
		let self = new Form( element );
		return element;

	}
	
	constructor( form ){

		this.form = form;
		this.form.clone = this.clone.bind( this );

		// The confimation-required actions
		Array.from(this.form.querySelectorAll('.confirm'))
			.map((el) => confirmated_click(el))

		this.form.addEventListener('submit', (e) => {

			e.preventDefault();

			// Validate
			if( this.form.querySelector(':invalid') ){
				return false;
			}

			// Ajaxify
			let params = {
				action: e.target.action,
				method: e.target.method ? e.target.method : 'POST',
			}
			Object.keys( params ).map((p) => {

				if( e.submitter.getAttribute(`form${p}`) )
					params[p] = e.submitter.getAttribute(`form${p}`);

			})

			params.body = new FormData( e.target );

			this.form.classList.add('processing');
			fetcher(
				params.action,
				params,
				(d) => {
					this.form.classList.remove('processing');
				},
				this.form
			).catch((q) => {
				console.log('Form submission failed totally!');
				this.form.classList.remove('processing');
			});

		});


		// Init inputs handlers and validators
		Array.from(this.form.elements).map((el) => {

			if( el.tagName == 'FIELDSET' )
				return;



			// Handlers
			Object.keys(Form.handlers).map((selector) => {

				if( el.matches( selector ) ){

					el.handler = Form.handlers[selector].getInstance( el );

				}

			})

			// Validators
			el.addEventListener('change', (e) => {

				if( el.name ){
					let checks = this.validateElement( el );

					checks.map((check) => {

						check.el.setCustomValidity( check.errors );

						let label = check.el.closest('[data-role="label"]') ?? check.el.closest('label');
						if( check.errors.length ){
							label.querySelector('.format_details')?.setAttribute('data-custom-format-info', check.el.validationMessage);
						} else{
							label.querySelector('.format_details')?.removeAttribute('data-custom-format-info');
						}

					});

				}

			});

			el.addEventListener('input', (e) => {

				if( el.name && el.validationMessage ){
					let checks = this.validateElement( el );

					let errors_count = checks.reduce(
						(acc,check) => acc + check.errors.length,
						0
					);

					if( !errors_count ){
						let label = el.closest('[data-role="label"]') ?? el.closest('label');
						label.querySelector('.format_details')?.removeAttribute('data-custom-format-info');
						el.setCustomValidity('');
					}
				}
			})


		})

	}

	validateElement( element ){

		let checks = [];
		let queue = [ element ]

		do{
			let el = queue.shift();

			// If el is a name string
			if( ! (el instanceof HTMLElement) )
				el = this.form.querySelector(`[name="${el}"]`);

			// Will not add same element twice
			if( checks.some( (check) => check.el == el ) )
				continue;

			let element_validators = el.getAttribute('data-validate')?.split(',');

			let rels = el.getAttribute('data-rel')?.split(',');
			let check = {
				el: el,
				errors: new FormErrorsSet(),
				validators: (
					element_validators
					? Object.fromEntries(
						element_validators.map(( v, idx ) => [ v, rels && rels[idx] ? rels[idx] : null ])
					)
					: {}
				)				
			};
			checks.push(check);

			queue.push( ... Object.values( check.validators ).filter((v) => v) );

		} while( queue.length );

		checks.map((check) => {

			if( ! check.el.validity.valid ){
				check.errors.add( this.#getGenericBrowserErrorMessage(check.el.validity, check.el) );
			}

			Object.keys(check.validators).map((v) => {
				validators[v]( check.el, check.validators[v], check.errors );
			});

			check.errors.clean();

		});

		return checks;

	}

	#getGenericBrowserErrorMessage( validity, el ){
		let messages = {
			email:{
				typeMismatch: 'Please enter a valid E-mail',
				valueMissing: 'Email required',
			},
			_default: {
				patternMismatch: 'Please use required format',
				tooLong: 'Too long',
				tooShort: 'Too short',
				rangeOverflow: 'Range overflow',
				rangeUnderflow: 'Range underflow',
				typeMismatch: 'Please use a valid format',
				valueMissing: 'Value required',
			}
		};

		let type = el.getAttribute('type');
		let queue = [messages._default]
		if( type && messages[type] )
			queue.unshift( messages[type] );

		for( let set of queue ){
			for( let key of Object.keys(set) ){
				if( validity[ key ] ){
					return i18n.ru( set[ key ] );
				}
			}
		}

	}


}




// The forms submit 
window.addEventListener('load', () => {

	Array.from(document.querySelectorAll('form'))
		.map((f) => {
			new Form( f );
		})

	document.addEventListener('modal_content_rendered', (e) => {

		if( e.detail.content.tagName == 'FORM' )
			new Form( e.detail.content );

	});

	document.addEventListener('delivered_markup_rendered', (e) => {

		e.detail.elements.map((el) => {
			if( el.tagName == 'FORM' )
				new Form( el )
		})

	});


	
});